export default {
  fieldIsRequired: {
    en: "Field is required",ch: "欄位為必填項",
    ja: "フィールドは必須項目です"
  }
}
